
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendars/[[...festival]]",
      function () {
        return require("private-next-pages/calendars/[[...festival]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendars/[[...festival]]"])
      });
    }
  